import { render, staticRenderFns } from "./AllStationsCarousel.vue?vue&type=template&id=38086bf1&scoped=true"
import script from "./AllStationsCarousel.vue?vue&type=script&lang=js"
export * from "./AllStationsCarousel.vue?vue&type=script&lang=js"
import style0 from "./AllStationsCarousel.vue?vue&type=style&index=0&id=38086bf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38086bf1",
  null
  
)

export default component.exports